<template>
  <section id="team-hero-section" class="supporter-hero-section">
    <h1 class="title is-size-1 pt-2 is-size-3-mobile">
      {{ $t("supporterHero.headline") }}
    </h1>
    <p class="subtitle pt-2 pb-5 mb-5 pr-7 hero-text is-size-4 is-size-5-mobile">
      {{ $t("supporterHero.subHeadline") }}
    </p>

    <div class="columns is-centered mb-6">
      <div class="hero-image-mask column is-three-fifths has-text-centered is-flex is-justify-content-start">
        <img
          src="~assets/images/supporter_logos/ministrerium-ftr.webp"
          class="logo-demkapps"
          alt="Logo des Bundesministeriums fiïr Forschung, Technologie und Raumfahrt"
        />
      </div>
      <div
        class="hero-description column has-text-primary is-flex is-flex-direction-column is-justify-content-center is-align-items-center"
      >
        <p class="ml-4 pt-2 pb-3 pr-7 hero-text is-size-6 is-size-6-mobile">
          memodio wird bei dem Projekt "DEMKAPPS1" gefördert durch das Bundesministrium für Forschung, Technologie und
          Raumfahrt.
        </p>
      </div>
    </div>

    <div class="columns is-centered mb-0 mt-5">
      <div class="hero-image-mask column is-three-fifths has-text-centered">
        <div class="is-centered">
          <img id="eu-logo" class="top-logo" src="~assets/images/supporter_logos/cofinanced-eu.webp" alt="EU Logo" />
          <p class="is-size-6 has-text-left">Gefördert aus Mitteln der Europäischen Union und des Landes Brandenburg</p>
        </div>
      </div>

      <div class="hero-description column has-text-primary">
        <p class="ml-4 pt-2 pb-3 pr-7 hero-text is-size-6 is-size-6-mobile">
          Die memodio GmbH vertreibt digitale Medizinprodukte zur Vorbeugung und Behandlung von Demenz. Im Rahmen der
          durch Gründung Innovativ zu fördernden Maßnahme sind vier Einzelvorhaben zur technischen Weiterentwicklung der
          Produkte zwecks der Verbesserung der Usability, Patientensicher und Therapieadherence geplant.
        </p>
      </div>
    </div>

    <div>
      <strong>
        Im Rahmen der Förderrichtlinie Brandenburger Innovationsfachkräfte 2022 werden folgende Projekte gefördert:
      </strong>
      <ul class="mt-2">
        <li>
          Eine Maßnahme zur innovativen Kreation eines Offline Marketingkonzepts Vorhabensbeschreibung: Die memodio GmbH
          entwickelt eine nichtmedikamentöse Therapie für leichte kognitive Störung (MCI). Um die Verbreitung der App zu
          sichern, wird ein innovatives Offline Marketingkonzepts unter Mitarbeiter einer Innovationsfachkraft
          geschaffen.
          <br />
          <b>Ziele:</b> Die Entwicklung eines datenschutzkonformen Offline Marketingkonzepts, das als Ergebnis Vertrauen
          schafft, Nutzer nachhaltig gewinnt und die Sichtbarkeit der App erhöht.
        </li>
        <li>
          Eine Maßnahme zur innovativen Kreation eines Online Marketingkonzepts: Vorhabensbeschreibung: Die memodio GmbH
          entwickelt eine nichtmedikamentöse Therapie für leichte kognitive Störung (MCI). Um die Verbreitung der App zu
          sichern, wird ein innovatives Performance-Marketingkonzepts unter Mitarbeiter einer Innovationsfachkraft
          geschaffen.<br />
          <b>Ziele:</b> Die Entwicklung eines datenschutzkonformen Performance-Marketingkonzepts, das als Ergebnis
          Vertrauen schafft, Nutzer nachhaltig gewinnt und die Sichtbarkeit der App erhöht.
        </li>
        <li>
          Eine Maßnahme zur innovativen Kreation eines Backends der memodio vida App Die memodio GmbH erweitert ihre
          Zielgruppe um Gebrechlichkeit/Senilität im spanischen Markt. Ziel ist es, ein neues Backend für den spanischen
          Markt zu erstellen, zu testen und an regulatorische Anforderungen anzupassen. Ergebnis ist ein
          funktionsfähiges, MDR-konformes Backend, das die App in Spanien nutzbar macht und langfristig die
          internationale Skalierung ermöglicht.
        </li>
        <li>
          Eine Maßnahme zur innovativen Kreation eines Frontends der memodio vida App Die memodio GmbH erweitert ihre
          Zielgruppe um Gebrechlichkeit/Senilität im spanischen Markt. Ziel ist es, ein neues Frontende für den
          spanischen Markt zu erstellen, zu testen und an regulatorische Anforderungen anzupassen. Ergebnis ist ein
          funktionsfähiges, MDR-konformes Frontend, das die App in Spanien nutzbar macht und langfristig die
          internationale Skalierung ermöglicht.
        </li>
      </ul>
    </div>

    <div class="columns is-centered mt-6 pt-4">
      <div class="hero-image-mask column is-three-fifths has-text-centered">
        <div class="is-centered">
          <img
            id="eu-logo"
            class="top-logo second-eu-flag"
            sizes="100vw"
            src="~assets/images/supporter_logos/eulogo.webp"
            alt="EU Logo"
          />
          <p class="is-size-6 has-text-left">
            {{ $t("supporterHero.supportExplanation") }}
          </p>
        </div>
      </div>

      <div class="hero-description column has-text-primary">
        <p class="ml-4 pt-2 pb-5 pr-7 hero-text is-size-6 is-size-6-mobile">
          {{ $t("supporterHero.esfExplanation") }}
          <br /><br />
          <b>{{ $t("supporterHero.measure") }}:</b>
          <br /><br />
          {{ $t("supporterHero.measureExplanation") }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SupporterHero",
}
</script>

<style lang="scss" scoped>
.top-logo {
  margin: 20px 0;
}

ul {
  list-style-type: circle;
  padding-left: 16px;
}

.second-eu-flag {
  padding-right: 200px;
}

.logo-demkapps {
  max-height: 320px;
}

.supporter-hero-section {
  @media screen and (min-width: $tablet) {
    padding-top: 80px;
    padding-bottom: 136px;
  }

  @media screen and (max-width: $tablet) {
    padding-top: 40px;
    padding-bottom: 64px;
  }
}
</style>
